import axios from 'axios';

class AppVersionApi {
  async getVersion() {
    return axios.get<Record<string, string>>('/version', { baseURL: '/' });
  }
}

export const appVersionApi = new AppVersionApi();